import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useReOrderTopic({ classID, courseID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function reOrderTopic({ chapterID, ...data } = {}) {
    return privateFetch
      .post(
        `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic/re-order`,
        data
      )
      .then((res) => res.data);
  }

  return useMutation(reOrderTopic, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters');
    },
  });
}

export default useReOrderTopic;
